export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_9977_EXPAND': 'Expand',
    '_9978_COLLAPSE': 'Collapse',
    '_763_CLOSE': 'Close',
    '_11208_CREATE_NOTES': 'Create Notes'
};
